import MiniCssExtractPlugin from 'mini-css-extract-plugin';
import { cwd } from '../generateConfig';

export const DEFAULT_INCLUDE_PATHS = [
  cwd('node_modules'),
];

export default (includePaths = DEFAULT_INCLUDE_PATHS, opts = {}) => ({
  test: /\.s?[ac]ss$/,
  use: [
    MiniCssExtractPlugin.loader,
    'css-loader',
    {
      loader: 'sass-loader',
      options: {
        includePaths,
        ...opts,
      },
    },
  ],
});
